import * as React from 'react';

import * as chatState from '@rematter/modules/chat/_state/chat.state';
import { Session } from '@talkjs/react';
import { useAtomValue, useSetAtom } from 'jotai';

import { config } from '~/config';
import { useIdentity } from '~/shared/hooks';

interface TalkJSProviderProps {
  children: React.ReactNode;
}

export const SyncChatUser = () => {
  const { user, organization } = useIdentity();
  const talkSession = useAtomValue(chatState.$talkSession);

  React.useEffect(() => {
    if (user?.id) {
      const fullName = [user?.firstName, user?.lastName]
        .filter(Boolean)
        .join(' ');

      const userData = {
        name: fullName,
        email: user?.email,
        custom: {
          contactType: 'internal',
          applicationUserId: user?.id,
          organizationName: organization?.name ?? '',
        },
      };

      talkSession?.currentUser?.createIfNotExists(userData).then(() => {
        talkSession?.currentUser.set(userData);
      });
    }
  }, [
    user?.id,
    user?.firstName,
    user?.lastName,
    user?.email,
    talkSession,
    user?.organizations,
    organization?.name,
  ]);

  return null;
};

export const TalkJSProvider = ({ children }: TalkJSProviderProps) => {
  const { user } = useIdentity();

  const setUserId = useSetAtom(chatState.$userId);

  React.useEffect(() => {
    if (user?.id) {
      setUserId(user.id);
    }
  }, [user?.id, setUserId]);

  return !user?.id ? (
    children
  ) : (
    <Session appId={config.talkJs.appId} userId={user.id}>
      <SyncChatUser />
      {children}
    </Session>
  );
};
